import 'css-chunk:src/applications/TermsApp/components/ContentGuidelines/ContentGuidelinesList/ContentGuidelinesList.module.scss';export default {
  "ContentGuidelinesList": "_ContentGuidelinesList_jgj8e_1",
  "center": "_center_jgj8e_9",
  "start": "_start_jgj8e_12"
};